import React, { useState, useEffect, useMemo } from 'react';

import Tool from 'components/tool/Tool';
import Back from 'components/common/Back';

import imageUrlFor from 'helpers/image-url';

const getBannerWidth = width => {
  if (width > 1280) return Math.round(width * 0.45);
  if (width > 992) return Math.round(width * 0.48);
  return width;
};

const CollectionDetail = ({ name, description, tools, image, prevPath, slug }) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const width = useMemo(() => {
    if (typeof window !== 'undefined') {
      return getBannerWidth(window.innerWidth);
    }
    return null;
  }, []);

  if (!isClient) return null;

  return (
    <div className="collection">
      <img
        src={width && imageUrlFor(image.asset.url).width(width).url()}
        alt=""
        className="poster"
      />
      <div className="offer">
        <Back label="Back" path={prevPath} color="#fff" />
        <h1 className="title">{name}</h1>
        <p className="description">{description}</p>
      </div>
      <div className="tools">
        {tools?.map(tool => (
          <Tool
            key={`collection-tool-${tool.slug.current}`}
            name={tool.name}
            logo={tool.logo}
            description={tool.description}
            path={`/collection/${slug.current}/${tool.slug.current}`}
          />
        ))}
      </div>
    </div>
  );
};

export default CollectionDetail;
